export default __webpack_public_path__ + "static/media/googlePlay.fbad1220.svg";